import { Box, Text } from '@wix/design-system';
import { useFormatDate } from '@wix/package-picker-shared';
import React from 'react';
import { useDowngradeModal } from '../../../hooks/useDowngradeModal';
import { SwitchProductModule } from '../../../switch-product.module';
export const StatusSummary = () => {
  var _downgradeDetails$des, _downgradeDetails$des2, _downgradeDetails$des3, _downgradeDetails$des4;
  const {
    t,
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const {
    downgradeDetails
  } = useDowngradeModal();
  const formatPrice = SwitchProductModule.SDK.useFormatPrice();
  const {
    locale
  } = SwitchProductModule.internals.useContext();
  const formatDate = useFormatDate({
    locale
  });
  const isGracePeriod = (downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'GracePeriod';
  if (isGracePeriod) {
    var _downgradeDetails$cur;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      marginBottom: "SP2",
      size: "small",
      dataHook: "gracePeriodMessage"
    }, t('change_plan.change_plan_modal.grace_message', {
      plan: downgradeDetails == null || (_downgradeDetails$cur = downgradeDetails.currentPlanDetails) == null ? void 0 : _downgradeDetails$cur.localizedProductName
    })), /*#__PURE__*/React.createElement(Text, {
      size: "small",
      dataHook: "continueToGraceMessage"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "change_plan.change_plan_modal.continue_to_grace",
      components: {
        1: /*#__PURE__*/React.createElement("b", null)
      }
    })));
  }
  const renewalDate = formatDate((downgradeDetails == null ? void 0 : downgradeDetails.newEndOfPeriod) ?? (downgradeDetails == null || (_downgradeDetails$des = downgradeDetails.destinationProductDetails) == null ? void 0 : _downgradeDetails$des.endOfPeriod));
  const renewalAmount = formatPrice((downgradeDetails == null || (_downgradeDetails$des2 = downgradeDetails.destinationProductDetails) == null ? void 0 : _downgradeDetails$des2.renewalPrice) ?? (downgradeDetails == null || (_downgradeDetails$des3 = downgradeDetails.destinationProductDetails) == null ? void 0 : _downgradeDetails$des3.totalPrice));
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    dataHook: ""
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "change_plan.change_plan_modal.next_renewal",
    values: {
      toPlan: downgradeDetails == null || (_downgradeDetails$des4 = downgradeDetails.destinationProductDetails) == null ? void 0 : _downgradeDetails$des4.localizedProductName,
      renewalDate,
      renewalAmount
    },
    components: {
      1: /*#__PURE__*/React.createElement("span", null)
    }
  }));
};
//# sourceMappingURL=StatusSummary.js.map